import {
  GridRenderCellParams,
  GridValidRowModel,
  GridTreeNodeWithRender,
  GRID_AGGREGATION_ROOT_FOOTER_ROW_ID,
} from "@mui/x-data-grid-premium";
import { Spacer, ButtonDS, DeleteOutlined } from "@qivia/ui";
import { useCallback } from "react";
import styled from "styled-components";
import { ExternalIbanModalState } from "../../modals/externalIbanModal";
import { ExternalIbanInput } from "../../companiesData/followUpInputs/externalIbanInput";

export const ExternalIbanCell = (props: {
  cellProps: GridRenderCellParams<
    GridValidRowModel,
    unknown,
    unknown,
    GridTreeNodeWithRender
  >;
  setModalState: (state: ExternalIbanModalState) => void;
  setResetIbanModalState: (state: ExternalIbanModalState) => void;
}) => {
  const { cellProps, setModalState, setResetIbanModalState } = props;
  const handleModalVisibility = useCallback(
    (visible: boolean, iban?: string, companyUuid?: string, name?: string) => {
      setModalState({
        isVisible: visible,
        ...(visible ? { iban, companyUuid, name } : {}),
      });
    },
    [setModalState],
  );

  const handleResetModalVisibility = useCallback(
    (visible: boolean, companyUuid?: string, name?: string, iban?: string) => {
      setResetIbanModalState({
        isVisible: visible,
        ...(visible ? { companyUuid, name, iban } : {}),
      });
    },
    [setResetIbanModalState],
  );

  const isLastRow = cellProps.id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID;
  const hasExternalIban = !!cellProps.value;

  if (isLastRow) {
    return <></>;
  }
  if (!hasExternalIban) {
    return (
      <ExternalIbanInput
        setIsExternalIbanModalVisible={(visible: boolean, iban?: string) =>
          handleModalVisibility(
            visible,
            iban,
            cellProps.row["companyUuid"] as string,
            cellProps.row["name"] as string,
          )
        }
      />
    );
  } else {
    return (
      <StyledExternalIbanContainer>
        <Spacer x={0.5} />
        {cellProps.value as string}
        <Spacer x={1} />
        <ButtonDS
          singleIcon={{ icon: <DeleteOutlined />, size: "S" }}
          format="fill"
          buttonType="danger"
          onClick={() =>
            handleResetModalVisibility(
              true,
              cellProps.row["companyUuid"] as string,
              cellProps.row["companyName"] as string,
              cellProps.value as string,
            )
          }
        />
      </StyledExternalIbanContainer>
    );
  }
};

const StyledExternalIbanContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;
